import App from "../../app";
import { ReviewScore } from "../../model/datasource/score";
import { ScoreFrontend } from "../frontend";
import {
	AttemptId,
	ProductId,
	ItemId,
	QuizId
} from "../../model/datasource";
import { ReviewSectionScoreChart } from "../../lib/chart";

export abstract class ScoreView<P extends ProductId, A extends AttemptId, Z extends QuizId, I extends ItemId> {
	frontend: ScoreFrontend;

	constructor(frontend?: ScoreFrontend) {
		this.frontend = frontend;
	}

	abstract init(app: App<P, A, Z, I>): void

	abstract displayReviewScores(chart: ReviewSectionScoreChart, scores: ReviewScore[]): void
}

export class NullScoreView<P extends ProductId, A extends AttemptId, Z extends QuizId, I extends ItemId> implements ScoreView<P, A, Z, I> {
	frontend: ScoreFrontend;

	init(app: App<P, A, Z, I>): void { }

	displayReviewScores(chart: ReviewSectionScoreChart, scores: ReviewScore[]): void {
		throw new Error("Method not implemented.");
	}
}

